import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Landing, AllProjects } from "./pages/index";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/allprojects" element={<AllProjects />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
